import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  @Input() isDark: boolean;
  @Input() visible: boolean = true;
  @Input() size: string = 'large';
  @Input() url: string = '/';

  goto() {
    if (this.url) window.location.href = this.url;
  }
}
